<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);">
            <i class="fa fa-shopping-cart text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Pedido de Vendas</h4>
            <p class="text-muted mb-0 small d-none d-lg-block">Gestão de pedidos e ordens de venda</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2 date-inputs-responsive">
                    <cec-input-data ref="edDT1" v-model="dt1" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1">até</span>
                    <cec-input-data ref="edDT2" v-model="dt2" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="btn-filtrar-responsive px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button ref="btAdicionar" variant="success" pill class="btn-adicionar-responsive px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span class="d-none d-sm-inline">Novo Pedido</span>
              <span class="d-sm-none">Novo</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">Nº Pedido</label>
                      <b-form-input type="text" v-model="pedido" placeholder="Ex: 12345" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">Cod. Controle</label>
                      <b-form-input type="text" v-model="id" placeholder="Ex: 987" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="8">
                      <cliente-pesquisa 
                        @retornaId="clienteId = $event"
                        :idInicial="clienteId"
                        label="Cliente"
                        place="Busque por nome ou código..."
                        labelBotao=""
                        ref="clientepesquisa"
                        idModal="clientepesquisa"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col md="12">
                      <label class="font-weight-bold text-muted small d-block mb-2">Situações</label>
                      <b-form-checkbox-group
                        v-model="tipoSituacao"
                        :options="filtro.tipoSituacaoOptions"
                        switches
                        class="custom-switch-premium"
                      ></b-form-checkbox-group>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0">
        <b-col sm="12" class="p-0">
          <b-table ref="tbl" 
                  id="table-transition-example"        
                  class="modern-premium-table"
                  :dark="isDark"
                  primary-key="SEQUENCIA"
                  responsive  hover  small  show-empty
                  empty-text="Informe o filtro para ver os registros "
                  :busy.sync="isBusy" 
                  :sticky-header="stickyHeight"
                  :tbody-tr-class="rowClassSelecionado"
                  :items="itensFiltrados" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="selecionarLinha"
                  @row-dblclicked="edit"
                  >
            <template #head(SEQUENCIA)>
              <SetFilter
                label="ID"
                v-model="filtros.SEQUENCIA"
                :options="opcoes.SEQUENCIA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>      
            <template #head(N_VENDA)>
              <SetFilter
                label="Pedido"
                v-model="filtros.N_VENDA"
                :options="opcoes.N_VENDA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template> 
            <template #head(NENTREGA)>
              <SetFilter
                label="Entrega"
                v-model="filtros.NENTREGA"
                :options="opcoes.NENTREGA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template> 
            <template #head(SITUACAO)>
              <SetFilter
                label="Situação"
                v-model="filtros.SITUACAO"
                :options="opcoes.SITUACAO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template> 
            <template #head(DT_PEDIDO)>
              <SetFilter
                label="D.Pedido"
                v-model="filtros.DT_PEDIDO"
                :options="opcoes.DT_PEDIDO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template> 
            <template #head(DT_SAIDA)>
              <SetFilter
                label="D.Fatura"
                v-model="filtros.DT_SAIDA"
                :options="opcoes.DT_SAIDA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template> 
            <template #head(DATA_EMBARQUE)>
              <SetFilter
                label="D.Embarque"
                v-model="filtros.DATA_EMBARQUE"
                :options="opcoes.DATA_EMBARQUE"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template> 
            <template #head(NOME_CLIENTE)>
              <SetFilter
                label="Cliente"
                v-model="filtros.NOME_CLIENTE"
                :options="opcoes.NOME_CLIENTE"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template> 
            <template #head(NOME_VENDEDOR)>
              <SetFilter
                label="Vendedor"
                v-model="filtros.NOME_VENDEDOR"
                :options="opcoes.NOME_VENDEDOR"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template> 
              <!-- Ícone de ação: seta -->
            <template #cell(DETALHE)="row">
              <i 
                :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                  @click.stop="toggleDetalhesVenda(row)"
                style="cursor: pointer"
              ></i>
            </template>
            <!-- Detalhes -->
            <template #row-details="row">
              <div v-if="row.item.loading">
                Carregando detalhes...
              </div>
              <div v-else>
                <b-table 
                  head-variant="dark"
                  hover="false"
                  :table-variant="isDark ? 'primary' : 'light'"
                  :items="row.item.detalhes" 
                  :fields="tabelaItens.fields">
                </b-table>
              </div>
            </template>      
            <template #cell(SITUACAO)="item">
              <b-badge pill :variant="colorirStatus(item.item.SITUACAO, item.item)">{{traduzirSituacao(item.item)}}</b-badge>
            </template>      
            <!--
            <template #cell(OP_PEDIDO)="item">
              <b-badge pill :variant="colorirTipoPedido(item.item.OP_PEDIDO)">{{traduzirTipoPedido(item.item.OP_PEDIDO)}}</b-badge>
            </template>      
            -->
            <template #cell(NOME_VENDEDOR)="item">
              {{ item.item.NOME_VENDEDOR }} - {{ item.item.COD_VENDEDOR }}
            </template>      
            <template #cell(NOME_CLIENTE)="item">
              {{ item.item.NOME_CLIENTE }} - {{ item.item.COD_CLI }}
            </template>      
            <template #cell(actions)="item" >
              <div class="d-flex align-items-center gap-1">
                <b-button type="button" @click="abrirModalInfo(item.item)" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Mais Detalhes" v-b-tooltip.hover>
                  <i class="fa fa-info"></i>
                </b-button>
                <b-button v-if="['2','3','7','8'].includes(item.item.SITUACAO)" type="button" @click="abrirModalCancelamento(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Cancelar" v-b-tooltip.hover>
                  <i class="fa fa-close"></i>
                </b-button>
                <b-dropdown v-if="item.item.SITUACAO != '2'" no-caret variant="link" toggle-class="p-0 no-decoration">
                  <template #button-content>
                    <b-button variant="soft-primary" pill class="btn-icon-only shadow-sm">
                      <i class="fa fa-print"></i>
                    </b-button>
                  </template>
                  <b-dropdown-item @click.stop.prevent="imprimirPedido(item.item.SEQUENCIA)">Imprimir Pedido</b-dropdown-item>
                  <b-dropdown-item @click.stop.prevent="imprimirPesagemExpedicao(item.item.SEQUENCIA)">Imprimir Pesagem Expedicao</b-dropdown-item>
                  <b-dropdown-item v-if="item.item.SITUACAO === '1'" @click.stop.prevent="imprimirFatura(item.item.SEQUENCIA)">Imprimir Fatura</b-dropdown-item>
                </b-dropdown>
                <b-button v-if="item.item.OP_PDF_ONLINE === '1'" type="button" @click="downloadPDFNfe(item.item)" variant="soft-secondary" pill class="btn-icon-only shadow-sm" title="Nota Fiscal" v-b-tooltip.hover>
                  <i class="fa fa-file-pdf-o"></i>
                </b-button>
                <b-button v-if="item.item.SITUACAO === '3' && parametrosExpedicao.OP_EXPEDICAO_DIRETA === '1'" type="button" @click="abrirModalLiberacaoTerminal(item.item)" variant="soft-success" pill class="btn-icon-only shadow-sm" title="Liberar para Terminal" v-b-tooltip.hover>
                  <i class="fa fa-terminal"></i>
                </b-button>
                <b-button v-if="item.item.SITUACAO === '3' && parametrosExpedicao.OP_EXPEDICAO_DIRETA === '2'" type="button" @click="solicitarSeparacao(item.item)" variant="soft-success" pill class="btn-icon-only shadow-sm" title="Solicitar Separacao" v-b-tooltip.hover>
                  <i class="fa fa-play"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL CANCELAMENTO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-cancelamento" 
          id="modal-cancelamento" 
          hide-header
          hide-footer
          centered
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          @shown="focusModalCancelamento()" 
      >
        <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                    no-wrap 
                    fixed 
                    z-index="1100" 
                    spinner-variant="danger"
                    spinner-type="border">
          <template #overlay>
            <div class="text-center bg-white p-4 rounded shadow-lg border">
              <b-icon icon="slash-circle" font-scale="3" class="text-danger mb-3" animation="pulse"></b-icon>
              <h5 class="font-weight-bold">Cancelando Venda...</h5>
              <p class="text-muted mb-0">Por favor, aguarde um momento.</p>
            </div>
          </template>
        </b-overlay>

        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #e53e3e 0%, #7d1c1c 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-times-circle text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Cancelar Venda</h5>
                <small class="text-white opacity-75">Anulação definitiva do pedido de venda</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-cancelamento')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-danger text-white">
                        <i class="fa fa-user"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">Cliente</small>
                        <span class="font-weight-bold text-dark">{{cancelamento.dados.nomeCliente}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">Pedido / Parcela</small>
                    <span class="badge badge-dark px-3">{{cancelamento.dados.documento}} - {{cancelamento.dados.parcela}}</span>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-md-6">
                    <div class="premium-summary-card p-3 rounded border bg-white shadow-xs h-100">
                        <small class="text-muted d-block mb-1">Data Vencimento</small>
                        <h5 class="mb-0 font-weight-bold text-dark">{{cancelamento.dados.dataVencimento}}</h5>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="premium-summary-card p-3 rounded border bg-white shadow-xs h-100">
                        <small class="text-muted d-block mb-1">Valor Total</small>
                        <h5 class="mb-0 font-weight-bold text-danger">{{cancelamento.dados.valorDocumento}}</h5>
                    </div>
                </div>
            </div>

            <div v-if="cancelamento.parametros.permissao === false" class="alert alert-danger border-0 shadow-sm d-flex align-items-center p-3 mb-0">
                <i class="fa fa-lock fa-2x mr-3"></i>
                <div>
                    <h6 class="mb-0 font-weight-bold">Acesso Negado</h6>
                    <small>Seu usuário não possui permissão para realizar cancelamentos.</small>
                </div>
            </div>

            <div v-if="cancelamento.parametros.permissao === true">
                <h6 class="modal-section-title mb-3">JUSTIFICATIVA</h6>
                <b-form-group label="Motivo do Cancelamento" label-class="modal-label-premium">
                    <b-form-textarea
                        ref="motivoCancelamento"
                        v-model="cancelamento.dados.motivo"
                        placeholder="Descreva detalhadamente o motivo do cancelamento..."
                        rows="3"
                        class="rounded-lg shadow-xs border-2"
                        :state="valMotivoCancelamento"
                    ></b-form-textarea>
                </b-form-group>

                <div class="d-flex justify-content-end gap-3 mt-4">
                    <b-button variant="outline-secondary" pill class="px-4" @click="$bvModal.hide('modal-cancelamento')">
                        DESISTIR
                    </b-button>
                    <b-button variant="danger" pill class="px-4 font-weight-bold shadow-sm" @click="cancelar()">
                        <i class="fa fa-check mr-1"></i> CONFIRMAR CANCELAMENTO
                    </b-button>
                </div>
            </div>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                        MODAL LIBERAÇÃO PARA TERMINAL 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-liberacao-terminal" 
          id="modal-liberacao-terminal" 
          hide-header
          body-class="p-0"
          size="lg"
          @shown="focusModalLiberacaoTerminal()" 
          headerClass= "p-2 border-bottom-0" 
          title="LIBERAR PARA TERMINAL" >
        <b-card bg-variant="light">
            <div slot="header">
                <i class='fa fa-truck'></i><strong>  Liberar Pedido para Terminal de Expedição</strong>
            </div>
            <b-row class="mb-3">
              <b-col cols="12" md="3">
                <label>Cliente:</label>
              </b-col>
              <b-col cols="12" md="9">
                <strong>{{liberacaoTerminal.dados.nomeCliente}}</strong>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="12" md="3">
                <label>Pedido:</label>
              </b-col>
              <b-col cols="12" md="3">
                <strong>{{liberacaoTerminal.dados.pedido}}</strong>
              </b-col>
            </b-row>
            <hr>
            <b-row class="mb-3">
              <b-col cols="12" md="3">
                  <label for="numeroEntrega">Número da Entrega <span class="text-danger">*</span></label>
              </b-col>
              <b-col cols="12" md="4">
                  <b-form-input type="number" 
                                ref="numeroEntrega" 
                                id="numeroEntrega" 
                                v-model.number="liberacaoTerminal.dados.numeroEntrega" 
                                :state="valNumeroEntrega"
                                min="1"
                                @keydown.enter="liberarParaTerminal()"
                                placeholder="Informe o número da entrega" ></b-form-input>
              </b-col>
            </b-row>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="success" @click="liberarParaTerminal()" :disabled="!valNumeroEntrega">
            <i class="fa fa-check"></i> CONFIRMAR LIBERAÇÃO
          </b-button>
          <b-button variant="danger" @click="cancel()">
            <i class="fa fa-times"></i> Cancelar
          </b-button>
        </template>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                            MODAL INFO 
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-info" 
          id="modal-info" 
          hide-header
          hide-footer
          centered
          size="xl"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
            <div class="d-flex align-items-center justify-content-center rounded-circle mr-3" style="width: 48px; height: 48px; background: rgba(255, 255, 255, 0.15);">
                <i class="fa fa-info-circle text-white" style="font-size: 24px;"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">DETALHES DO PEDIDO</h5>
                <small class="text-white opacity-75">Informações completas da venda</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-info')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <h6 class="modal-section-title mb-3">INFORMAÇÕES GERAIS</h6>
            <div class="row mb-3">
                <div class="col-md-3">
                    <div class="premium-summary-card p-3 rounded border bg-light shadow-xs h-100">
                        <small class="text-muted d-block mb-1">Controle ID</small>
                        <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalInfo.id}}</h6>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="premium-summary-card p-3 rounded border bg-light shadow-xs h-100">
                        <small class="text-muted d-block mb-1">Nº Pedido</small>
                        <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalInfo.documento}}</h6>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="premium-summary-card p-3 rounded border bg-light shadow-xs h-100">
                        <small class="text-muted d-block mb-1">Data Venda</small>
                        <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalInfo.dataVenda}}</h6>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="premium-summary-card p-3 rounded border bg-success shadow-xs h-100">
                        <small class="text-white d-block mb-1">Valor Total</small>
                        <h6 class="mb-0 font-weight-bold text-white">{{dadosModalInfo.total}}</h6>
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-md-6">
                    <div class="modal-info-bar p-3 rounded d-flex align-items-center bg-light border">
                        <div class="avatar-circle mr-3 bg-primary text-white">
                            <i class="fa fa-user"></i>
                        </div>
                        <div>
                            <small class="text-muted d-block">Cliente</small>
                            <span class="font-weight-bold text-dark">{{dadosModalInfo.nomeCliente}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="modal-info-bar p-3 rounded d-flex align-items-center bg-light border">
                        <div class="avatar-circle mr-3 bg-info text-white">
                            <i class="fa fa-user-tie"></i>
                        </div>
                        <div>
                            <small class="text-muted d-block">Vendedor</small>
                            <span class="font-weight-bold text-dark">{{dadosModalInfo.nomeVendedor}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="dadosModalInfo.usuarioAlteracao || dadosModalInfo.dataAlteracao || dadosModalInfo.motivoAlteracao">
                <h6 class="modal-section-title mb-3">DADOS DE ALTERAÇÃO</h6>
                <div class="alert alert-info border-0 shadow-xs p-3 mb-4">
                    <div class="row">
                        <div class="col-md-3 mb-2 mb-md-0">
                            <small class="text-muted d-block">Data</small>
                            <strong>{{dadosModalInfo.dataAlteracao || '—'}}</strong>
                        </div>
                        <div class="col-md-3 mb-2 mb-md-0">
                            <small class="text-muted d-block">Usuário</small>
                            <strong>{{dadosModalInfo.usuarioAlteracao || '—'}}</strong>
                        </div>
                        <div class="col-md-6">
                            <small class="text-muted d-block">Motivo</small>
                            <strong>{{dadosModalInfo.motivoAlteracao || '—'}}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="dadosModalInfo.usuarioCancelamento || dadosModalInfo.dataCancelamento || dadosModalInfo.motivoCancelamento">
                <h6 class="modal-section-title mb-3">DADOS DE CANCELAMENTO</h6>
                <div class="alert alert-danger border-0 shadow-xs p-3 mb-4">
                    <div class="row">
                        <div class="col-md-3 mb-2 mb-md-0">
                            <small class="text-white d-block">Data</small>
                            <strong class="text-white">{{dadosModalInfo.dataCancelamento || '—'}}</strong>
                        </div>
                        <div class="col-md-3 mb-2 mb-md-0">
                            <small class="text-white d-block">Usuário</small>
                            <strong class="text-white">{{dadosModalInfo.usuarioCancelamento || '—'}}</strong>
                        </div>
                        <div class="col-md-6">
                            <small class="text-white d-block">Motivo</small>
                            <strong class="text-white">{{dadosModalInfo.motivoCancelamento || '—'}}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <h6 class="modal-section-title mb-3">ITENS DO PEDIDO</h6>
            <b-table 
                striped 
                hover 
                show-empty
                empty-text="Venda sem Produtos lançados"
                stacked="md"
                small
                bordered
                responsive 
                select-mode="single"
                head-variant="dark"
                selectable
                :items="tabelaItens.items" 
                :fields="tabelaItens.fields"
                class="modern-premium-table mb-0">
            </b-table>

            <div class="modal-footer-premium d-flex justify-content-end gap-3 mt-4 pt-3 border-top">
                <b-button variant="secondary" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-info')">
                    <i class="fa fa-times mr-1"></i> FECHAR
                </b-button>
            </div>
        </div>
      </b-modal>
    </div>

    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="modalConfirmacaoAberto = true"
      @hidden="modalConfirmacaoAberto = false"
    />
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';
import CecInputData from '@/components/Cec/CecInputData.vue'
import { imprimirPedidoEstimado } from './PedidoEstimadoHTML'

export default {
  components: {
    ClientePesquisa,
    ModalAlertaResultadoGrande,
    SetFilter,
    CecInputData
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'SEQUENCIA', type: 'number', label: 'ID' },
      { key: 'N_VENDA', type: 'string', label: 'Pedido' },
      { key: 'NENTREGA', type: 'number', label: 'Entrega' },
      { key: 'SITUACAO', type: 'string', label: 'Situação' ,
        labelMap: { '0': 'Cancelado', '1': 'Fechado', '2': 'Lançando', '3': 'Aguardando Ordem', '4': 'Ordem Expedição', '5': 'Embarcando', '6': 'Conferido/Pronto p/ Venda', '7': 'Aguardando Separacao', '8': 'Em Separacao' } },
      /*{ key: 'OP_PEDIDO', type: 'string', label: 'Tipo' ,  labelMap: { '1': 'Venda Normal', '2': 'Retirada Serviço'}},*/
      { key: 'NOME_CLIENTE', type: 'string', label: 'Cliente'  },
      { key: 'NOME_VENDEDOR', type: 'string', label: 'Vendedor'  },
      { key: 'ORDEM_EXPEDICAO_ID', type: 'string', label: 'Ordem Exp.'  },
      { key: 'DATA_EMBARQUE', type: 'date', label: 'Embarque'  },
      { key: 'USUARIO_PEDIDO', type: 'string', label: 'Usuário'  },
      { key: 'DT_PEDIDO', type: 'date', label: 'Pedido'  },
      { key: 'DT_SAIDA', type: 'date', label: 'Fatura'  }
    ]
  })],

  data () {
    return {
      filtro: {
        avancado: false,
        tipoSituacaoOptions: [
          { value: '0', text: 'Cancelado' },
          { value: '1', text: 'Fechado' },
          { value: '2', text: 'Lancando' },
          { value: '3', text: 'Aguardando Ordem' },
          { value: '4', text: 'Ordem Expedicao' },
          { value: '5', text: 'Embarcando' },
          { value: '6', text: 'Conferido/Pronto p/ Venda' },
          { value: '7', text: 'Aguardando Separacao' },
          { value: '8', text: 'Em Separacao' }
        ]
      },
      parametrosExpedicao: {
        OP_EXPEDICAO_DIRETA: '0'
      },
      liberacaoTerminal: {
        dados: {
          id: null,
          nomeCliente: '',
          pedido: '',
          numeroEntrega: null
        }
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      dadosModalInfo: {
        id: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        usuarioAlteracao: null,
        dataAlteracao: null,
        motivoAlteracao: null,
        usuarioCancelamento: null,
        dataCancelamento: null,
        motivoCancelamento: null,
        total: 0.00

      },
      tabelaItens: {
        registroSelecionadoId : null,
        fields: [
          {
            key: "CODIGO_NOME_PRODUTO",
            label: 'Produto'
          },
          {
            key: "PECAS_PEDIDO",
            class:'text-right', 
            label: 'Pedido'
          },
          {
            key: "PECAS",
            class:'text-right', 
            label: 'Embarcado'

          },
          {
            key: "TX_UNIDADE_COMERCIAL",
            label: 'UND'
          },
          {
            key: 'VL_UNT', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          }
        ],
        items: []
      },
      status: '',
      isBusy: false,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      fields: [
        {
          key: "DETALHE",
          class:'align-middle text-center p-0',
          label: '',
          thStyle: { width: "2%" }
        },
        {
          key: "SEQUENCIA",
          label: 'Id',
          sortable: true
        },
        {
          key: "N_VENDA",
          label: 'Pedido', 
          sortable: true 
        },
        {
          key: "NENTREGA",
          label: 'N.Entrega',
          sortable: true 
        },
        {
          key: "SITUACAO",
          label: 'Situação',
          sortable: true 
        },
        //{          key: "OP_PEDIDO",          label: 'Tipo Pedido',          sortable: true         },
        {
          key: "DT_PEDIDO",
          label: 'Dt. Pedido', 
          sortable: true,
          formatter: (value, key, item) => 
            value ? moment(String(value)).format('DD/MM/YYYY') : null
        },
        {
          key: "DT_SAIDA",
          label: 'Dt. Fatura', 
          sortable: true,
          formatter: (value, key, item) => 
            value ? moment(String(value)).format('DD/MM/YYYY') : null
        },
        {
          key: "NOME_CLIENTE",
          label: 'Nome do Cliente',
          sortable: true 
        },
        {
          key: "NOME_VENDEDOR",
          label: 'Vendedor', 
          sortable: true 
        },
        {
          key: "ORDEM_EXPEDICAO_ID",
          label: 'Ordem Exp.', 
          class:'text-right p-0 align-middle',
          sortable: true 
        },
        {
          key: "DATA_EMBARQUE",
          label: 'D.Embarque',
          class:'text-right p-0 align-middle', 
          sortable: true,
          formatter: (value, key, item) => 
            value ? moment(String(value)).format('DD/MM/YYYY') : null
        },
        
        {
          key: "USUARIO_PEDIDO",
          label: 'Usuário', 
          sortable: true 
        },
        {
          key: "actions" ,
          label: 'Ações',
           class:'text-right p-0 align-middle'
        }
      ],
      modalDetails: { index: '', data: '' },
      columns: [
        {title: 'ID', dataKey: 'id'},
        {title: 'Name', dataKey: 'name'},
        {title: 'Country', dataKey: 'country'}
      ],
      rows: [
        {'id': 1, 'name': 'Shaw', 'country': 'Tanzania'},
        {'id': 2, 'name': 'Nelson', 'country': 'Kazakhstan'},
        {'id': 3, 'name': 'Garcia', 'country': 'Madagascar'}
      ]
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    valMotivoCancelamento() {
      return ((this.cancelamento.dados.motivo ) && (this.cancelamento.dados.motivo != '')) ? true : false 
    },
    valNumeroEntrega() {
      return this.liberacaoTerminal.dados.numeroEntrega && 
             this.liberacaoTerminal.dados.numeroEntrega > 0
    },
    proximoNumeroEntrega() {
      if (!this.lista || this.lista.length === 0) return 1
      const numeros = this.lista
        .map(item => item.NENTREGA)
        .filter(n => n != null && !isNaN(n))
      return numeros.length > 0 ? Math.max(...numeros) + 1 : 1
    },
    user () {
      return '' // this.$store.state.dadosSessao.nome
    },
    currentPage: {
      get () {
        return this.$store.getters['pedidoVendaWeb/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("pedidoVendaWeb/SET_PAGINA_ATUAL", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['pedidoVendaWeb/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('pedidoVendaWeb/SET_PER_PAGE', Number(v) || 25)
      }
    },
    
    dt1: {
      get () {
        return this.$store.getters['pedidoVendaWeb/DT1']
      }, 
      set (value) {
        this.$store.commit("pedidoVendaWeb/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['pedidoVendaWeb/DT2']
      }, 
      set (value) {
        this.$store.commit("pedidoVendaWeb/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['pedidoVendaWeb/ID']
      }, 
      set (value) {
        this.$store.commit("pedidoVendaWeb/SET_ID", value);
      }
    },
    pedido: {
      get () {
        return this.$store.getters['pedidoVendaWeb/PEDIDO']
      }, 
      set (value) {
        this.$store.commit("pedidoVendaWeb/SET_PEDIDO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['pedidoVendaWeb/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("pedidoVendaWeb/SET_CLIENTE_ID", value)
      }
    },
    tipoSituacao: {
      get () {
        return this.$store.getters['pedidoVendaWeb/TIPO_SITUACAO']
      }, 
      set (value) {
        this.$store.commit("pedidoVendaWeb/SET_TIPO_SITUACAO", value)
      }
    },
    lista: {
      get () {
        return this.$store.getters['pedidoVendaWeb/LISTA']
      }, 
      set (value) {
        this.$store.commit("pedidoVendaWeb/SET_LISTA", value)
      }
    }
  },
  methods: {
    async buscarParametrosExpedicao() {
      try {
        const response = await this.$http.get('/api/protected/parametro/getParametrosExpedicao')
        if (response.data && response.data.length > 0) {
          this.parametrosExpedicao = response.data[0]
        }
      } catch (erro) {
        console.error('Erro ao buscar parâmetros de expedição:', erro)
        // Mantém valores padrão em caso de erro
      }
    },
    selecionarLinha(item) {
      this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['pedidoVendaWeb/REGISTRO_SELECIONADO_ID']
      return item.SEQUENCIA === selId ? 'cec-row-selected' : ''
    },
    
    async toggleDetalhesVenda(row) {
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", row.item.SEQUENCIA)

      if (!row.item.detalhes && !row.item.loading) {
        this.$set(row.item, 'loading', true)

        const detalhes = await this.buscarDetalhesVenda(row.item.SEQUENCIA)

        this.$set(row.item, 'detalhes', detalhes)
        this.$set(row.item, 'loading', false)
      }

      row.toggleDetails()
    },

    async onToggleDetails(row, expanded) {
      // Apenas necessário se quiser reagir diretamente ao evento
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.fields,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de Pedidos de Venda',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Período: ${this.dt1} a ${this.dt2}`,
        pageSize: 'A4',
        landscape: true,
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'pedidos_venda.xls'
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'pedidos_venda.csv',
      });
    },

    async buscarDetalhesVenda(id) {
      // Simula chamada backend

      const itensResult = await this.$http.get('/api/protected/venda/item/getListagemByVenda/'+id)
      return itensResult.data ?? null

    },
    
    async cancelar() {
      if (!this.valMotivoCancelamento) {
        this.toastCount++
        this.$root.$bvToast.toast('Informe o motivo!', {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      
      try {
        try {
          this.$store.commit('controle/setAguardando', true)
          this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", null)
          const dados = {
            usuario: window.localStorage.getItem('login'),
            vendaId: this.cancelamento.dados.id,
            motivo: this.cancelamento.dados.motivo,
            origem: 'web'
          }

          await this.$http.post( `/api/protected/vendapedido/deleteDesktop/`, dados)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
      
        await this.$store.dispatch('pedidoVendaWeb/GERAR_LISTA')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Pedido excluído com sucesso!' )

      } finally {
        this.$refs['modal-cancelamento'].hide()
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    abrirModalInfo(item) {

      this.$store.commit('controle/setAguardando', true)
      this.tabelaItens.items = null
      this.dadosModalInfo.id = null
      this.dadosModalInfo.documento = null
      this.dadosModalInfo.dataVenda = null
      this.dadosModalInfo.nomeCliente = null
      this.dadosModalInfo.nomeVendedor = null
      this.dadosModalInfo.total = null
      
      this.dadosModalInfo.usuarioAlteracao = null
      this.dadosModalInfo.dataAlteracao = null
      this.dadosModalInfo.motivoAlteracao = null
      this.dadosModalInfo.usuarioCancelamento = null
      this.dadosModalInfo.dataCancelamento = null
      this.dadosModalInfo.motivoCancelamento = null
      
      this.$http.get('/api/protected/venda/item/getListagemByVenda/'+item.SEQUENCIA)
      .then((response) => {
        this.tabelaItens.items = response.data
        this.dadosModalInfo.id = item.SEQUENCIA
        this.dadosModalInfo.documento = item.N_VENDA
        this.dadosModalInfo.dataVenda = item.DT_SAIDA ? moment(String(item.DT_SAIDA)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.nomeCliente = item.NOME_CLIENTE
        this.dadosModalInfo.nomeVendedor = item.NOME_VENDEDOR
        this.dadosModalInfo.total = item.VL_TOTAL_NFE ? item.VL_TOTAL_NFE.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
        
        this.dadosModalInfo.usuarioAlteracao = item.TX_USUARIO_ALTERACAO
        this.dadosModalInfo.dataAlteracao = item.DT_ALTERACAO ? moment(String(item.DT_ALTERACAO)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.motivoAlteracao = item.OBS3
        this.dadosModalInfo.usuarioCancelamento = item.TX_USUARIO_CANCELAMENTO
        this.dadosModalInfo.dataCancelamento = item.DT_CANC ? moment(String(item.DT_CANC)).format('DD/MM/YYYY') : ''
        this.dadosModalInfo.motivoCancelamento = item.MOT_CANC

        this.$refs['modal-info'].show()
        this.$store.commit('controle/setAguardando', false)
      })
    },
    async abrirModalCancelamento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.get(`api/protected/venda/getPermiteAlterar/${item.SEQUENCIA}`)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        this.cancelamento.dados.titulo = item.N_VENDA
        this.cancelamento.dados.id = item.SEQUENCIA
        this.cancelamento.dados.nomeCliente = item.NOME_CLIENTE
        this.cancelamento.dados.documento = item.N_VENDA
        this.cancelamento.dados.motivo = ''
        this.cancelamento.dados.dataVencimento = moment(String(item.DT_SAIDA)).format('DD/MM/YYYY')
        this.cancelamento.dados.valorDocumento = item.VL_TOTAL_NFE ? item.VL_TOTAL_NFE.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
        this.cancelamento.dados.usuario = window.localStorage.getItem('login')

        //venda Aberta
        if (this.lista.SITUACAO === '2') {
            this.cancelamento.parametros.permissao = true
            this.cancelamento.parametros.processando = false
            this.cancelamento.parametros.busy = true
            this.$refs['modal-cancelamento'].show()
            return
        }
          
        this.cancelamento.parametros.permissao = true
        this.cancelamento.parametros.processando = false
        this.cancelamento.parametros.busy = true
        this.$refs['modal-cancelamento'].show()
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    abrirModalLiberacaoTerminal(item) {
      this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
      this.liberacaoTerminal.dados.id = item.SEQUENCIA
      this.liberacaoTerminal.dados.nomeCliente = item.NOME_CLIENTE
      this.liberacaoTerminal.dados.pedido = item.N_VENDA
      this.liberacaoTerminal.dados.numeroEntrega = this.proximoNumeroEntrega
      this.$refs['modal-liberacao-terminal'].show()
    },
    async solicitarSeparacao(item) {
      const confirmar = await this.$bvModal.msgBoxConfirm(`Solicitar separacao do pedido ${item.N_VENDA || item.SEQUENCIA}?`, {
        title: 'Solicitar Separacao',
        okTitle: 'SIM, SOLICITAR',
        cancelTitle: 'CANCELAR',
        okVariant: 'success',
        centered: true
      })
      if (!confirmar) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('/api/protected/vendapedido/solicitarSeparacao', {
          pedidoId: item.SEQUENCIA,
          usuario: window.localStorage.getItem('login')
        })
        await this.$store.dispatch('pedidoVendaWeb/GERAR_LISTA')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Pedido enviado para separacao!')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalLiberacaoTerminal() {
      this.$refs.numeroEntrega.focus()
    },
    async liberarParaTerminal() {
      if (!this.valNumeroEntrega) {
        this.$root.$bvToast.toast('Informe um número de entrega válido (maior que zero)!', {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post(`/api/protected/vendapedido/liberarParaTerminal/${this.liberacaoTerminal.dados.id}/${this.liberacaoTerminal.dados.numeroEntrega}`, {
          usuario: window.localStorage.getItem('login')
        })
        await this.$store.dispatch('pedidoVendaWeb/GERAR_LISTA')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Pedido liberado para terminal com sucesso!' )
        this.$refs['modal-liberacao-terminal'].hide()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async downloadPDFNfe (item) {
      this.$store.commit('controle/setAguardando', true)
      let uri = `/api/protected/notaFiscal/downloadPDFVendaId/${item.SEQUENCIA}`
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Nota Fiscal Eletronica.pdf') 
          link.download = 'NFe.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Nota Fiscal Eletronica'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(async error => {
          this.$store.commit('controle/setAguardando', false)
          //if (erro.response.status == 400) {
            //console.log(error.response.data)
            //const blob = new Blob([JSON.stringify(error.response.data)])

            var textdata = ''
            if (error.response.request.responseType === 'arraybuffer'
              && error.response.data.toString() === '[object ArrayBuffer]'
            ) {
              var buffer = new Buffer(error.response.data, 'binary')
              textdata = buffer.toString()
            } else {
              textdata = erro.response.data
            }
            
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${textdata}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          //}
        })
    },
    focusModalCancelamento() {
      this.$refs.motivoCancelamento.focus()
    },
    limpar() {
      this.$store.commit("pedidoVendaWeb/SET_LIMPAR", null)
    },
    colorirTipoPedido(valor) {
      if (valor == '1') return 'info'
      else if (valor == '2') return 'secondary'
      else 'second'
    },
    traduzirTipoPedido(valor) {
      if (valor === '1') return 'VENDA'
      else if (valor === '2') return 'RETIRADO SERVIÇO'
      else 'INVALIDO'
    },
    getStatusOrdemEntrega(item) {
      return String((item && item.ORDEM_ENTREGA_STATUS) || '').trim()
    },
    isEntregaConfirmada(item) {
      return String((item && item.OP_RETORNO_ENTREGA) || '0').trim() === '1'
    },
    colorirStatus(valor, item = null) {
      if (valor == '0') return 'danger'
      else if (valor == '1') {
        if (item && this.isEntregaConfirmada(item)) return 'success'
        if (!item || !item.ORDEM_ENTREGA_ID) return 'success'
        const statusOrdem = this.getStatusOrdemEntrega(item)
        if (statusOrdem === '1') return 'primary'
        if (['2', '3', '4'].includes(statusOrdem)) return 'info'
        return 'primary'
      }
      else if (valor == '2') return 'warning'
      else if (valor == '3') return 'info'
      else if (valor == '4') return 'secondary'
      else if (valor == '5') return 'indigo'
      else if (valor == '6') return 'primary'
      else if (valor == '7') return 'warning'
      else if (valor == '8') return 'indigo'
      else return 'info'
      
    },
    traduzirSituacao(registro) {
      const item = registro && typeof registro === 'object' ? registro : null
      const valor = item ? item.SITUACAO : registro
      if (valor === '0') return 'CANCELADO'
      else if (valor === '1') {
        if (item && this.isEntregaConfirmada(item)) return 'ENTREGUE'
        if (!item || !item.ORDEM_ENTREGA_ID) return 'FECHADO / AGUARD. CARGA'
        const statusOrdem = this.getStatusOrdemEntrega(item)
        if (statusOrdem === '1') return 'EM EMBARQUE'
        if (['2', '3', '4'].includes(statusOrdem)) return 'EMBARCADO'
        return 'EM EMBARQUE'
      }
      else if (valor === '2') return 'LANÇANDO'
      else if (valor === '3') return 'AGUARD. ORDEM'
      else if (valor === '4') return 'ORDEM EXP'
      else if (valor === '5') return 'EMBARCANDO'
      else if (valor === '6') return item && String(item.OP_CONFERENCIA_VENDA || '0').trim() === '1' ? 'CONFERIDO / PRONTO P/ VENDA' : 'EMBARCADO'
      else if (valor === '7') return 'AGUARDANDO SEPARACAO'
      else if (valor === '8') return 'EM SEPARACAO'
      else return ''
    },
    details (item) {
      alert(JSON.stringify(item.item.SEQUENCIA))
    },
    edit (item) {
      this.$store.commit('controle/setAguardando', true)
      this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
      this.$router.push(`/movimentos/pedidovendaweb/edit/${item.SEQUENCIA}`)
    },
    novo () {
      this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", null)
      this.$router.push(`/movimentos/pedidovendaweb/add`)
    },
    async pesquisar() {
      if (this.modalConfirmacaoAberto) {
        return;
      }
      this.$store.commit("pedidoVendaWeb/SET_REGISTRO_SELECIONADO_ID", null)
      try {
        this.$store.commit('controle/setAguardando', true)
        this.status = false
        const result = await this.$store.dispatch('pedidoVendaWeb/GERAR_LISTA')
        
        if (result.needsConfirmation) {
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        this.status = true
      } catch (error) {
        this.status = false
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$store.dispatch('pedidoVendaWeb/GERAR_LISTA', { skipConfirmation: true })
        this.status = true
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      } catch (error) {
        this.status = false
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Informação', 'info', 'Carregamento de resultado grande cancelado')
    },

    async imprimirFatura (id) {
      try {
        this.$store.commit('controle/setAguardando', true)

        try {
          this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", id)
          const relPayLoad = {
            id: id,
            login: window.localStorage.getItem('login')
            
          }
          const response =   await this.$http.post(`/api/protected/relatorios/relvenda`, relPayLoad, { responseType: 'arraybuffer' })
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relVenda.pdf') 
          link.download = 'relVenda.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Vendas'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async imprimirPedido (id) {
      this.$store.commit('controle/setAguardando', true)
      try {
        await imprimirPedidoEstimado(this.$http, id)
        this.$root.$bvToast.toast(`RelatÃ³rio Gerado com sucesso!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'success',
          appendToast: true
        })
      } catch (erro) {
        this.$toast.error({
          title: 'Erro',
          message: 'Ocorreram erros ao gerar o Relatorio ',
          progressBar: false,
          showMethod: 'shake',
          position: 'top full width'
        })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      return
      let uri = '/api/protected/relatorios/relvendapedido?id=' + id
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relVendaPedido.pdf') 
          link.download = 'relVendaPedido.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Pedido de Venda'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
        })
    },
     async imprimirPesagemExpedicao (id) {
      try {
        this.$store.commit('controle/setAguardando', true)

        try {
          this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", id)
          const relPayLoad = {
            id: id,
            login: window.localStorage.getItem('login')
            
          }
          const response =   await this.$http.post(`/api/protected/relatorios/relVendaPedidoPesagemExpedicao`, relPayLoad, { responseType: 'arraybuffer' })
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relVenda.pdf') 
          link.download = 'relVenda.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Vendas'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.$refs.btAdicionar.click()
      } 
    }
  },
  
  async created () {
    // Buscar parâmetros de expedição
    await this.buscarParametrosExpedicao()
  },
  mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
      this.tabelaItens.registroSelecionadoId = this.$store.getters['pedidoVendaWeb/REGISTRO_SELECIONADO_ID'] ? parseInt(this.$store.getters['pedidoVendaWeb/REGISTRO_SELECIONADO_ID']) : null
      
    }, 200)
    this.$nextTick(() => {
      this.$refs.edDT1?.focus()
    })
  },
  beforeDestroy() {
    // Remove o evento de keydown ao destruir o componente
    document.removeEventListener("keydown", this.handleKeydown);
  },
  watch: {
  }
}
</script>
<style >
/* Responsividade do Header Premium */
@media (max-width: 991px) {
  .search-pill-responsive {
    flex-wrap: wrap;
    border-radius: 1rem !important;
    padding: 0.5rem !important;
  }
  
  .date-inputs-responsive {
    flex-wrap: wrap;
    border-left: none !important;
    padding-left: 0 !important;
    width: 100%;
    justify-content: center;
    margin-bottom: 0.5rem;
  }
  
  .btn-filtrar-responsive {
    width: 100%;
    margin-top: 0.25rem;
  }
}

@media (max-width: 767px) {
  .list-header-premium {
    gap: 0.5rem !important;
    padding-bottom: 1rem !important;
  }
  
  .list-header-premium .p-3 {
    padding: 0.75rem !important;
  }
  
  .search-pill-responsive {
    width: 100%;
    margin-right: 0 !important;
    border-radius: 1.5rem !important;
  }
  
  .btn-adicionar-responsive {
    width: 100%;
    margin-top: 0.5rem;
  }
}

@media (max-width: 575px) {
  .date-inputs-responsive .mx-1 {
    width: 120px !important;
    margin: 0.25rem !important;
  }
  
  .btn-filtrar-responsive .fa-search {
    margin-right: 0 !important;
  }

  .header-icon-wrapper {
    width: 38px;
    height: 38px;
  }
  
  .header-text-container h4 {
    font-size: 1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/pedidovenda/PedidoVendaListagemWeb.vue